import React from "react";

import { batchVideoAnalysisService } from "../../../services/batch-processing/BatchVideoAnalysisService";
import useThemeService from "../../../services/theme-service/ThemeService";
import { translationService } from "../../../services/translation/TranslationService";
import Svg from "../../svg/Svg";
import { Success, Error } from "../../svg/svgImageList";
import { BatchProcessingType, StatusTableHeader, StatusTableRow } from "./StatusTableComponents";

export default function BatchVideoAnalysisStatus() {
  return (
    <section className="batch-processing-status-container">
      <h4>
        {translationService.translate("damages.BatchProcessingStatus.message", {
          itemsCount: batchVideoAnalysisService.statusModel.videoCount,
        })}
      </h4>

      <div className={"batch-processing-result-summary success"}>
        <Svg svg={Success} width={20} />
        <p className="batch-processing-summary-text success">
          {translationService.translate("damages.BatchProcessingStatus.success", {
            itemsCount: batchVideoAnalysisService.statusModel.successfullyCount,
          })}
        </p>
      </div>

      <div className={"batch-processing-result-summary error"}>
        <Svg svg={Error} width={20} />
        <p className="batch-processing-summary-text">
          {translationService.translate("damages.BatchProcessingStatus.fail", {
            itemsCount: batchVideoAnalysisService.statusModel.failedCount,
          })}
        </p>
      </div>

      <BatchVideoAnalysisStatusTable />
    </section>
  );
}

const BatchVideoAnalysisStatusTable = () => {
  const { themeClass } = useThemeService();
  return (
    <>
      <table className={themeClass(["batch-processing-status-table"])}>
        <thead>
          <StatusTableHeader />
        </thead>
        <tbody>
          <StatusTableRow batchProcessingType={BatchProcessingType.VideoAnalysis}/>
        </tbody>
      </table>
    </>
  );
}
